import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

const SvgComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={19} height={42} fill="none" {...props}>
        <Path
            fill={designSystem.colors.neutral900}
            stroke={designSystem.colors.neutral400}
            d="M17.97.5v40.204H7.736v-27.48L1.234 16.67l-.734.389V6.906l.27-.14L12.758.556 12.866.5h5.104Z"
        />
    </Svg>
);
export { SvgComponent as OneIcon };
